import { render, staticRenderFns } from "./SpeedTest.vue?vue&type=template&id=4dfaa832&scoped=true&"
import script from "./SpeedTest.vue?vue&type=script&lang=js&"
export * from "./SpeedTest.vue?vue&type=script&lang=js&"
import style0 from "./SpeedTest.vue?vue&type=style&index=0&id=4dfaa832&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfaa832",
  null
  
)

export default component.exports